var _style, _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgSvgF(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1473 769",
    style: {
      enableBackground: "new 0 0 1473 769"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{opacity:0.4;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);enable-background:new    ;}\n\t.st2{opacity:0.4;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 1473,
    height: 769
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.7318,
    y1: 341.3006,
    x2: 118.8298,
    y2: 1049.9525,
    gradientTransform: "matrix(0.9988 -4.858422e-02 -4.858422e-02 -0.9988 34.2974 773.6259)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2873,
    style: {
      stopColor: "#516BF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#19AEFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.8-184.3c-30.1,63.6-185.1,92.6-214.2,203c-29.1,110.4,61.6,164.6,39.7,230.9 C-116.7,316-88,356.5-52.5,368.1c35.5,11.6,84.1-4.4,99.6-51.3c15.5-46.9,65.2-63,139.3-73.3c74.1-10.3,99.4-121.9,126.4-246.3 c22.3-102.7-31.2-175.5-85.9-207c-2.8-1.6,0,0-8.6-4.7C160.2-246.5,109.9-247.9,79.8-184.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1500.3425,
    y1: 787.2604,
    x2: 1379.1724,
    y2: 159.4058,
    gradientTransform: "matrix(-0.9808 -0.1949 -0.1949 0.9808 2912.0195 474.2349)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7A60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD5E60"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1370.7,910.7c37.6-59.5,194.9-69.5,237.2-175.6c42.3-106.1-41.3-170.8-11.5-234 c29.8-63.2,6.3-106.9-27.6-122.7c-33.8-15.8-84-5.8-105,38.9c-21,44.6-72.3,54.6-147.1,55.9c-74.8,1.2-113.4,109-155.2,229.2 c-34.6,99.3,9.8,178,60.2,215.9c2.6,2,0,0,7.9,5.7C1283.3,962.7,1333.1,970.2,1370.7,910.7z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSvgF);
export default __webpack_public_path__ + "static/media/bg-svg-f.192609b8540a56a36a47cf339386fe08.svg";
export { ForwardRef as ReactComponent };